import Swiper from "../Swiper/Swiper"

const BasicSwiper: React.FC<{ title?: string }> = ({
  title = "Comparamos entre más de 50 Compañías Eléctricas",
}) => {
  return (
    <Swiper
      title={title}
      slidesPerView={6}
      images={[
        "/Images/landing/swiper-logos/Endesa-Logo-2048x1152.png",
        "/Images/landing/swiper-logos/Plenitude-Logo.png",
        "/Images/landing/swiper-logos/Naturgy-ok.png",
        "/Images/landing/swiper-logos/total_logo.png",
        "/Images/landing/swiper-logos/412562538-axpo.png",
        "/Images/landing/swiper-logos/Iberdrola_logo_new.png",
        "/Images/landing/swiper-logos/Logo_Audax.png",
        // "/Images/landing/swiper-logos/Repsol-logo-logotype.png",
        "/Images/landing/swiper-logos/syder_logo.png",
        "/Images/landing/swiper-logos/eleia-logo.png",
        "/Images/landing/swiper-logos/logo-visalia.png",
        "/Images/landing/swiper-logos/gana-energia-logo.png",
        // "https://res.cloudinary.com/dzzkeb6xp/image/upload/v1684618870/r7ce5pnobwowqssivulp-modified_il6luv.png",
      ]}
      headingLevel={"h2"}
    />
  )
}

export default BasicSwiper
